import { Component, Vue } from 'vue-property-decorator'
import { validEmail, validUserName, isBetween, validPassword} from '../../../helper-functions/validators'
import textInput from '../../../components/text-input/text-input.vue'

@Component({
  components: {
    textInput,
  }
})

export default class AddModerator extends Vue {

  private namespace: string = '/Console';
  
  private userId: string | null = null;

  private username: string = '';

  private name: string = '';

  private email: string = '';

  private password: string = '';

  private passwordMatch: string = '';

  private alertMessage: string = '';

  private submitted: boolean = false;

  private loadingThreshold: number | undefined = undefined;

  private error: boolean = false;

  private disabled: boolean = false;

  private get ValidPassword(): boolean {

    return validPassword(this.password, this.username);
  }

  private get ConfirmedPassword(): boolean {

    return this.password != '' && this.password === this.passwordMatch;
  }

  private get ValidUsername() {

    return validUserName(this.username);
  }

  private get ValidName() {

    return isBetween(5, 100, this.name) && this.name != null && this.name !== '';
  }

  private get ValidEmail() {

    return validEmail(this.email);
  }

  private get UserId(): string | null {

    return this.userId != null
      ? this.userId
      : null;
  }

  private get enabled() {

    return  this.ValidName
      && this.ValidUsername
      && this.ValidEmail
      && this.ValidPassword
      && this.ConfirmedPassword
      && !this.disabled;
  }

  private alertReset() {

    setTimeout(() => {

      if (this.error) {

        this.error = !this.error;
      }

      this.alertMessage = '';
    }, 5000);
  }

  private async register() {

    this.submitted = true;

    try {

      const response = await this.$axios.post(`${this.$apiUrl + this.namespace}/AddModerator`, {
        UserName: this.username,
        FullName: this.name,
        Email: this.email,
        Password: this.password
      });

      this.submitted = false;
      this.alertMessage = 'New Moderator Successfully added';
      this.alertReset();
    } catch (err) {

      this.submitted = false;
      this.error = !this.error;
      this.alertMessage = this.$t('errors.general') as string;
      this.alertReset();
    }
  }
}